import DomainConfigurationModal from './DomainConfigurationModal'

export default DomainConfigurationModal
